import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function Login({ setIsLoggedIn }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (!username || !password) {
      setError('Invalid username and password.');
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/login`, {
        username,
        password,
      });

      if (response.data.message === 'Login successful') {
        localStorage.setItem('authToken', response.data.token);
        localStorage.setItem('userRole', response.data.user.role); // Store role
        setIsLoggedIn(true);
        navigate('/');
      }
    } catch (error) {
      setError('Invalid username or password');
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <h2>Admin Login</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>} {/* Show error if login fails */}
      <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', width: '300px' }}>
        <label>
          Username:
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={{ padding: '10px', margin: '10px 0', border: '1px solid black', borderRadius: '4px', }}
          />
        </label>
        <label>
          Password:
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ padding: '10px', margin: '10px 0', border: '1px solid black', borderRadius: '4px', }}
          />
        </label>
        <button type="submit" style={{ padding: '10px', margin: '10px 0', backgroundColor: 'grey', color: 'white' }}>Login</button>
      </form>
    </div>
  );
}